module.exports = __webpack_public_path__ + "static/media/StationF1.daa02495.jpg";